<template>
  <section class="news">
    <div class="newsgrid">
      <div class="newrelease"></div>
      <div class="newreleasecover">
        <img src="../assets/POM52_.jpg" alt="POM52" />
      </div>
      <div class="presstext">
        <h3><i>Out July 10</i></h3>
        <h4>Lodig/Dibek - Glass Echoes</h4>
        <p class="rec-info">
          <i>
            Lodig / Dibek re-emerge with a new 12”, expertly delivering that
            analogue machine funk.<br />

            On the A-side, Glass Echoes, features two cuts between techno and
            electro, navigating between darkness and light, rawness and polished
            brilliance. <br />

            Neon Drive comes in two variations on the flip - dark and extra
            funky electro driven by conversing baselines, followed by a
            dubbed-out version designed for those moody late-night moments.
          </i>
        </p>
      </div>
      <iframe
        style="border: 0; width: 100%; height: 120px"
        class="player2"
        src="https://bandcamp.com/EmbeddedPlayer/album=2511897058/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/"
        seamless
        ><a href="https://pomelo.bandcamp.com/album/glass-echoes-pom52"
          >Glass Echoes / POM52 by Lodig/Dibek</a
        ></iframe
      >
    </div>
  </section>
</template>
<style scoped>
/* Base styles */
body {
  font-family: "Roboto", sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f9f9f9;
  color: #333;
}

/* News section */
.news {
  padding: 25px 15px;
  margin: auto;
  max-width: 1200px;
  background-color: #ffffff;
}

/* Grid layout */
.newsgrid {
  display: grid;
  grid-template-rows: auto auto 1fr auto;
  grid-template-columns: 1fr 2fr 2fr 1fr;
  gap: 20px;
  align-items: center;
}

.newrelease {
  grid-column: 2 / 3;
  text-align: left;
  height: 50px;
}

.newreleasecover {
  grid-column: 2 / 3;
  align-self: start;
}

.newreleasecover img {
  max-width: 100%;
  height: auto;
  border-radius: 5px;
  transition: transform 0.3s ease-in-out;
}

.newreleasecover img:hover {
  transform: scale(1.05);
}

/* Press text */
.presstext {
  grid-column: 3 / 4;
  padding: 0 20px 10px 20px;
  text-align: justify;
  line-height: 1.6;
}

.presstext h3 {
  font-size: 1.1rem;
  color: #fff;
  background-color: #ccc;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 0;
}

.presstext h4 {
  margin-top: 20px;
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #333;
  /* text-align: center; */
}

.presstext p {
  font-size: 1rem;
  color: #666;
}
.rec-info a {
  text-decoration: none;
  color: #000;
}

/* Bandcamp player */
.player2 {
  grid-column: 2 / span 2;
  margin: auto;
  max-width: 500px;
}

/* Responsiveness */
@media screen and (max-width: 768px) {
  .newsgrid {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
  }

  .newrelease,
  .newreleasecover,
  .presstext,
  .player2 {
    grid-column: 1;
  }

  .presstext {
    padding: 10px;
  }
}

@media screen and (min-width: 1800px) {
  .newreleasecover img {
    width: 100%;
    max-width: 400px;
  }
  .presstext {
    font-size: 1.2rem;
    line-height: 1.8;
  }
}
</style>
